import { forwardRef, useContext } from "react";
import {
  type ButtonProps as ButtonPrimitiveProps,
  PopoverContext as PopoverPrimitiveContext,
} from "react-aria-components";
import {
  CoreTooltipIconButton,
  type PropsWithOptionalTestID,
} from "@boi/components-core";

import * as S from "./TooltipIconButtonV2.styled";

export type TooltipIconButtonV2Props = PropsWithOptionalTestID &
  Required<Pick<ButtonPrimitiveProps, "aria-label">> &
  Omit<ButtonPrimitiveProps, "children" | "aria-expanded"> & {
    variant?: CoreTooltipIconButton.Variant;
  };

const TooltipIconButtonV2 = forwardRef<
  HTMLButtonElement,
  TooltipIconButtonV2Props
>((props, ref) => {
  const {
    variant = CoreTooltipIconButton.DEFAULT_VARIANT,
    testID = "tooltip-icon-button",
    ...otherProps
  } = props;

  const popoverPrimitiveContext = useContext(PopoverPrimitiveContext);
  const tooltipRole = popoverPrimitiveContext ? "dialog" : "tooltip";

  return (
    <S.Button
      {...otherProps}
      ref={ref}
      $tooltipRole={tooltipRole}
      $variant={variant}
      data-testid={testID}
    >
      <S.Container $variant={variant}>
        {tooltipRole === "tooltip" && (
          <>
            <S.TooltipIcon $variant={variant} />
            <S.TooltipIconFilled $variant={variant} />
          </>
        )}

        {tooltipRole === "dialog" && (
          <>
            <S.DialogIcon $variant={variant} />
            <S.DialogIconFilled $variant={variant} />
          </>
        )}
      </S.Container>
    </S.Button>
  );
});

TooltipIconButtonV2.displayName = "TooltipIconButtonV2";

export default TooltipIconButtonV2;
